import "./product.css";
import React from "react";
import data from "../product/data";
import ProductComponent from "../../component/ProductComponent";
const Product = () => {
  return (
    <section id="product">
      <div className="product__all">
        <h2 className="productName">Our Product</h2>
        <div className="product-grid">
          {data.map(ProductComponent)}
        </div>
      </div>
    </section>
  );
};

export default Product;
